module.exports = __webpack_public_path__ + "img/logoBlack.cd163c6d.png";